import * as components from './components'

export default [
  {
    path: '/microCompetencyManagement',
    component: components.MicroCompetencyList,
    name: 'microCompetencyList',
    props: true
  },
  {
    path: '/microCompetency/create',
    component: components.MicroCompetencyCreate,
    name: 'microCompetencyCreate',
    props: true
  },
  {
    path: '/microCompetency/:uuid/edit',
    component: components.MicroCompetencyCreate,
    name: 'microCompetencyEdit',
    props: true
  },
  {
    path: '/microCompetency/:uuid/player',
    component: components.MicroCompetencyPlayer,
    name: 'microCompetencyPlayer',
    props: true
  },
  {
    path: '/microCompetency/:uuid/prereq',
    component: components.MicroCompetencyPreReq,
    name: 'microCompetencyPreReq',
    props: true
  },
  {
    path: '/course/:uuid/curatenew',
    component: components.CourseCurationNew,
    name: 'courseCurationNew',
    props: true
  },
  {
    path: '/microCompetency/:uuid/curate',
    component: components.MicroCompetencyCurate,
    name: 'microCompetencyCurate',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/microCompetency/routes.js